// Decodifica o payload de um JWT sem validar a assinatura (a validação é do backend).
// Substitui `decode` do pacote `jsonwebtoken`, que arrasta polyfills de crypto (~600 KiB)
// para o bundle inicial só para fazer este base64 + JSON.parse.
export const decode = token => {
  if (typeof token !== "string") return null;

  const parts = token.split(".");
  if (parts.length !== 3) return null;

  try {
    const base64 = parts[1].replace(/-/g, "+").replace(/_/g, "/");
    const padded = base64 + "=".repeat((4 - (base64.length % 4)) % 4);
    const json = decodeURIComponent(
      atob(padded)
        .split("")
        .map(char => `%${`00${char.charCodeAt(0).toString(16)}`.slice(-2)}`)
        .join("")
    );

    return JSON.parse(json);
  } catch (error) {
    return null;
  }
};

export default decode;
